<div class="page-layout simple full-width">
    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div *ngIf="!isLoading" fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Sección: {{ item.title }} </div>
        </div>

        <button mat-button [routerLink]="'/' + pathUrlList" class="mt-0 mt-md-0">
            <mat-icon>arrow_back</mat-icon>
            <span>Volver</span>
        </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

            <mat-progress-bar *ngIf="isLoading" mode="buffer"></mat-progress-bar>

            <!-- REACTIVE FORM EXAMPLE -->

            <div *ngIf="!isLoading" class="mat-card mat-elevation-z4 p-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">

                <mat-form-field appearance="outline" fxFlex="80">
                    <mat-label>¿ Mostrar Banner ?</mat-label>
                    <mat-select name="is_show_banner" [(ngModel)]="item.data.is_show_banner">
                        <mat-option [value]="true">
                            SI
                        </mat-option>
                        <mat-option [value]="false">
                            NO
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                    <mat-form-field appearance="outline" class="pl-4">
                        <mat-label>Primer texto (en negrita)</mat-label>
                        <input matInput [name]="'first_text'" [(ngModel)]="item.data.first_text" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="pl-4">
                        <mat-label>Texto</mat-label>
                        <input matInput [name]="'two_text'" [(ngModel)]="item.data.two_text" />
                    </mat-form-field>

                    <div class="pl-4" style="margin-bottom: 20px;">
                        <mat-label>Imagen de fondo</mat-label>
                        <div fxLayout="row">
                            <mat-spinner *ngIf="isUploadingFile['image_product_0']" [diameter]="50"></mat-spinner>
                            <img *ngIf="item.data.image_product && item.data.image_product.length > 0" [src]="item.data.image_product" class="m-b-5" style="width: 100px; height: 100px; object-fit: cover; margin-right: 10px;" /><br/>
                            <div *ngIf="!isUploadingFile['image_product_0']">
                                <input #inputFile type="file" (change)="onUploadFiles($event.target.files, { key: 'image_product', index: 0 }, item.data)" style="display: none;" />
                                <button mat-raised-button type="button" class="btn btn-outline-secondary" (click)="inputFile.click()">Subir imagen <i class="fa fa-upload"></i></button><br/>
                                <!--<button *ngIf="item[field.key] && item[field.key].length > 0" mat-raised-button color="warn"  type="button" class="ml-1 btn btn-outline-danger" (click)="item[field.key] = ''" style="margin-top: 5px;">Eliminar <i class="fa fa-trash"></i></button>-->
                            </div>
                        </div>
                    </div>

                    <mat-form-field appearance="outline" class="pl-4">
                        <mat-label>Texto del Boton</mat-label>
                        <input matInput [name]="'button_text'" [(ngModel)]="item.data.button_text" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="pl-4">
                        <mat-label>URL del Boton</mat-label>
                        <input matInput [name]="'button_url'" [(ngModel)]="item.data.button_url" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="80">
                        <mat-label>¿ Mostrar Boton ?</mat-label>
                        <mat-select name="is_show_button" [(ngModel)]="item.data.is_show_button">
                            <mat-option [value]="true">
                                SI
                            </mat-option>
                            <mat-option [value]="false">
                                NO
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                

                <mat-progress-bar *ngIf="isSending" mode="buffer"></mat-progress-bar>

                <div *ngIf="!isSending" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <button [routerLink]="'/' + pathUrlList" mat-raised-button color="warn" class="mt-24 mt-md-0 mr-4">
                        <span>Cancelar</span>
                    </button>

                    <button type="button" (click)="onClickSave()" mat-raised-button color="primary" class="mt-24 mt-md-0">
                        <span>Guardar y volver</span>
                    </button>
                </div>



            </div>

            <!-- / REACTIVE FORM EXAMPLE -->

        </div>

    </div>
    <!-- / CONTENT -->
</div>